// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__Ci8Qb","loaderOuter":"PageOverlayLoader_loaderOuter__2v4iL"};